/** Bản EN của `vi/contact.ts` — xem file đó để biết vì sao tách ba mảnh. */
export const contact = {
  /** Tiêu đề dialog — render bằng <h2>, và `aria-labelledby` trỏ vào nó. */
  title: 'Get in touch',
  before: 'Please contact ',
  email: 'support@newera.inc',
  after: ' for more information.',
  /** Nhãn nút mailto ở footer — KHÁC dialog: nó gửi thẳng mail, không mở dialog. */
  footerCta: 'Contact support',
  close: 'Close',
};
